import { computed, Injectable, signal } from '@angular/core';


@Injectable({ providedIn: 'root' })
export class LoaderService {
  private activeRequests = signal<number>(0);
  readonly isLoading = computed(() => this.activeRequests() > 0);

show(): void {
  this.activeRequests.update(c => c + 1);
}

hide(): void {
  this.activeRequests.update(c => c - 1);
}

    // Add this for emergencies
    forceStop(): void {
    this.activeRequests.set(0);
    }
}
